import React from 'react'
import setCancelableTimeout from '../utils/setCancelableTimeout'

enum DisplayState {
  Exited = 'Exited',
  Exiting = 'Exiting',
  PreEnter = 'PreEnter',
  Entering = 'Entering',
}

/**
 *
 * @param shouldBeShown
 * @param animationDuration
 * @returns [should render, should show]
 */
export default function useAnimateOutState(shouldBeShown: boolean, animationDuration: number): [boolean, boolean] {
  const [displayState, setListDisplayState] = React.useState(DisplayState.Exited)

  React.useEffect(() => {
    if (shouldBeShown) {
      if (displayState === DisplayState.PreEnter) {
        return setCancelableTimeout(() => {
          setListDisplayState(DisplayState.Entering)
        }, 10)
      } else if (displayState !== DisplayState.Entering) {
        setListDisplayState(DisplayState.PreEnter)
      }
    } else {
      if (displayState !== DisplayState.Exited && displayState !== DisplayState.Exiting) {
        setListDisplayState(DisplayState.Exiting)
      } else {
        return setCancelableTimeout(() => {
          setListDisplayState(DisplayState.Exited)
        }, animationDuration)
      }
    }

  }, [displayState, shouldBeShown, animationDuration])

  return [displayState !== DisplayState.Exited, displayState === DisplayState.Entering]
}